<div
    #root
    class="[&>ul]:flex [&>ul]:flex-wrap [&>ul]:gap-2">
</div>

